var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "35%", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v(" Delete " + _vm._s(_vm.groupInfo.groupName) + " ")
          ]),
          _c("v-card-text", [
            _vm._v(
              " Are you sure you want to delete " +
                _vm._s(_vm.groupInfo.groupName) +
                "? "
            ),
            _vm.groupInfo.lastItemSources.length > 0
              ? _c(
                  "div",
                  { staticStyle: { "margin-top": "25px" } },
                  [
                    _c(
                      "v-alert",
                      { attrs: { text: "", type: "warning", border: "left" } },
                      [
                        _c("p", [
                          _vm._v(
                            "Groups/stores from the following divisions will no longer have eligible items applied:"
                          )
                        ]),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.groupInfo.lastItemSources.join(", "))
                            )
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { disabled: _vm.deleting },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { loading: _vm.deleting },
                  on: { click: _vm.deletePromoItemGroup }
                },
                [_vm._v(" Submit ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }